<template>
  <b-card>
    <monitoramento-list
      ref="monitoramentoList"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
      :tem-filtro-extra="false"
      :show-botao-custom="true"
      :tem-filtro-rapido="false"
      :esconder-acoes="true"
      :mostrar-acoes-padrao="false"
      class="monitoramentoHover"
    >
      <template slot="show-botao-custom">
        <download-em-excel
          :filtro="filtroAtual"
          tipo="Monitoramento 360"
          :api="apiMonitoramento"
          :get-info-extra="montarDto"
        />
      </template>
      <template
        slot="custom-header"
        slot-scope="{ props} "
      >
        <div class="d-flex align-items-center justify-content-between">
          <span>{{ props.column.label }}</span>
          <b-button
            variant="light"
            size="sm"
            class="ml-1 d-flex align-items-center justify-content-center"
            @click.stop="props.column.field === 'situacao' ? alternarSituacaoGeral() : visualizarGrupo(props.column.field) "
          >
            <feather-icon
              :icon="props.column.field === 'situacao'
                ? (expandindoSituacaoGeral ? 'ChevronLeftIcon' : 'ChevronRightIcon')
                : (colunasExpandidas[props.column.field] ? 'ChevronDownIcon' : 'ChevronRightIcon')"
              size="15"
            />
          </b-button>
        </div>
      </template>

      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <tooltip-situacao
          v-if="props.column.field === 'situacao'"
          :row="props.row"
          class="situacao-cell-hover"
        >
          <span
            v-if="props.row[props.column.field] === 'regular'"
          >
            <feather-icon
              icon="CheckCircleIcon"
              size="25"
              style="margin: 0 5px; color: #74B491;"
            />
          </span>
          <span
            v-else-if="props.row[props.column.field] === 'irregular'"
          >
            <feather-icon
              icon="XCircleIcon"
              size="25"
              style="margin: 0 5px; color: #EA5455;"
            />
          </span>
          <span
            v-else-if="props.row[props.column.field] === 'motivo'"
          >
            <feather-icon
              icon="MinusCircleIcon"
              size="25"
              style="margin: 0 5px; color: #283046;"
            />
          </span>
          <b-badge
            v-else
            variant="light-primary"
            class="badge-size-p"
          >
            -
          </b-badge>
        </tooltip-situacao>
        <span
          v-else-if="props.row[props.column.field] === 'regular'"
        >
          <feather-icon
            icon="CheckCircleIcon"
            size="25"
            style="margin: 0 5px; color: #74B491;"
          />
        </span>
        <span
          v-else-if="props.row[props.column.field] === 'irregular'"
        >
          <feather-icon
            icon="XCircleIcon"
            size="25"
            style="margin: 0 5px; color: #EA5455;"
          />
        </span>
        <span
          v-else-if="props.row[props.column.field] === 'motivo'"
        >
          <feather-icon
            icon="MinusCircleIcon"
            size="25"
            style="margin: 0 5px; color: #283046;"
          />
        </span>
        <b-badge
          v-else-if="props.column.field !== 'situacao'"
          variant="light-primary"
          class="badge-size-p"
        >
          -
          {{ props.row[props.column.field] }}
        </b-badge>
      </template>

      <template
        slot="acoes"
        slot-scope="{ props }"
      >
        <div class="acoes-wrapper">
          <span
            v-b-tooltip.hover
            title="Visualizar pendências"
          >
            <b-btn
              variant="none"
              class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
              @click="abrirPendencias(props.row)"
            >
              <font-awesome-icon
                :icon="faMagnifyingGlass"
                class="text-primary"
              />
            </b-btn>
          </span>

          <span
            v-b-tooltip.hover
            title="Download documentos"
          >
            <b-btn
              variant="none"
              class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
              @click="baixarDocumentos(props.row)"
            >
              <feather-icon
                icon="DownloadIcon"
                class="text-primary"
                size="20"
              />
            </b-btn>
          </span>

          <span
            v-b-tooltip.hover
            title="Visualizar documentos"
          >
            <b-btn
              variant="none"
              class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
              @click="visualizarDocumentos(props.row)"
            >
              <font-awesome-icon
                icon="fa-sharp fa-regular fa-clipboard"
                class="text-primary"
                style="font-size:1.3rem !important;width:22px"
              />
            </b-btn>
          </span>

          <span
            v-b-tooltip.hover
            title="Observação"
          >
            <b-btn
              variant="none"
              class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
              @click="openModalObservacao(props.row)"
            >
              <font-awesome-icon
                icon="fa-regular fa-message"
                :class="getObservacaoClass(props.row)"
              />
            </b-btn>
          </span>
        </div>
      </template>
    </monitoramento-list>
    <div
      ref="legenda"
    >
      <span class="text-nowrap item-legenda">
        Legenda:
        <feather-icon
          icon="CheckCircleIcon"
          size="25"
          style="margin: 0 5px; color: #74B491;"
        />
        <span class="text-nowrap">
          Regular
        </span>
      </span>

      <span class="text-nowrap item-legenda">
        <feather-icon
          icon="XCircleIcon"
          size="25"
          style="margin: 0 5px; color: #EA5455;"
        />
        Irregular
      </span>

      <span class="text-nowrap item-legenda">
        <feather-icon
          icon="MinusCircleIcon"
          size="25"
          style="margin: 0 5px; color: #283046;"
        />
        Motivo
      </span>

      <span class="text-nowrap item-legenda">
        <b-badge
          variant="light-primary"
          class="badge-size-p"
        >
          -
        </b-badge>
        Sem dados
      </span>
    </div>

    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :descricao="descricaoLoading"
    />

    <pendencias-monitoramento-360
      v-if="empresaSelecionada"
      :empresa-id="empresaSelecionada.id"
      :empresa-nome="empresaSelecionada.razaoSocial"
      @hidden="empresaSelecionada = null"
    />

    <modal-observacao
      v-if="empresaObservacao"
      ref="modalObservacao"
      v-model="empresaObservacao"
      :api="apiMonitoramento"
      :notificar="{ sucesso: $sucesso, erro: $erro }"
      @hidden="fecharObservacao($event)"
    />

    <visualizar-arquivo
      v-if="mostrarVisualizacao && urlVisualizacao"
      :url="urlVisualizacao"
      @hidden="fecharVisualizacao()"
    />
  </b-card>
</template>

<style lang="scss">
// deixa colunas fixas na tela
.col-sticky {
  position: sticky !important;
  background: white !important;
}

// coloca a coluna de razão social como primeira coluna fixa
.col-sticky-1 {
  left: 0 !important;
  min-width: 250px !important;
}

// coloca a coluna de cadastro federal como segunda coluna fixa
.col-sticky-2 {
  left: 248px !important;
}

// deixa o cabeçalho a frente dos outros
.frente {
  z-index: 1;
}

// deixa coluna de ações fixa a direita
.col-sticky-right {
  position: sticky !important;
  right: 0 !important;
  background: white !important;
}

.acoes-wrapper {
  position: sticky;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 0.3rem;
}

.col-valores {
  white-space: nowrap;
}

[dir] #baixaPortalSelect .vs__dropdown-toggle {
  border-color: var(--primary) !important;
}

.item-legenda {
  margin: 5rem;
}

// garante que o span wrapper do vue-good-table não restrinja o tooltip
.vgt-table td .situacao-cell-hover {
  display: flex !important;
  width: 100%;
}
</style>

<script>
// import vSelect from 'vue-select'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import api from './shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'
import colunas from './shared/components/colunas'

export default {
  name: 'Monitoramento360View',
  components: {
    // vSelect,
    MonitoramentoList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    VisualizarArquivo: () => import('@pilar/components/visualizar-arquivo/VisualizarArquivo.vue'),
    Loading: () => import('@pilar/components/loading/Loading.vue'),
    DownloadEmExcel: () => import('@app/download-excel/DownloadEmExcel.vue'),
    TooltipSituacao: () => import('./shared/components/tooltip-situacao/TooltipSituacao.vue'),
    PendenciasMonitoramento360: () => import('./shared/components/pendencias/PendenciasMonitoramento360.vue'),
    ModalObservacao: () => import('@app/shared/components/modal-observacao/ModalObservacao.vue'),
  },

  data() {
    return {
      faMagnifyingGlass,
      mostarArquivo: false,
      arquivo: '',
      empresaNome: '',
      empresaSelecionada: null,
      botoesOption: null,
      empresaObservacao: null,
      observacaoEstado: {},
      mostrarVisualizacao: false,
      urlVisualizacao: null,
      descricaoLoading: '',
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social',
        acaoClass: 'col-td-acao-4',
        disabledCheckbox: false,
        colunas: [],
      },
      filtros: [
        {
          colunas: [
            'CadastroFederalSemMascara',
            'CadastroFederal',
            'RazaoSocial',
          ],
          valor: null,
        },
      ],
      filtrosDefaultDocs: [],
      filtrosRapidosDocs: [],
      filtrosRapidos: [],
      filtroString: [],
      filtroAtual: {},
      apiMonitoramento: api,
      isLoading: false,
      colunasExpandidas: {
        federal: false,
        certidoes: false,
        parcelamentos: false,
        simplesNacionalInfo: false,
      },
      expandindoSituacaoGeral: false,
    }
  },
  created() {
    this.visualizacao.colunas = JSON.parse(JSON.stringify(colunas))
    this.visualizacao.evento = this.carregar
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  methods: {
    montarDto() {
      if (this.$refs.monitoramentoList) {
        const empresas = this.$refs.monitoramentoList.linhaSelecionada
        this.filtroAtual.empresasSelecionadas = !empresas ? [] : empresas
        return this.filtroAtual
      }
      return undefined
    },
    resetarEstadoColunas() {
      this.expandindoSituacaoGeral = false
      Object.keys(this.colunasExpandidas).forEach(grupo => {
        this.colunasExpandidas[grupo] = false
      })
    },
    alternarSituacaoGeral() {
      this.expandindoSituacaoGeral = !this.expandindoSituacaoGeral

      this.visualizacao.colunas.forEach(col => {
        if (['federal', 'certidoes', 'parcelamentos', 'simplesNacionalInfo'].includes(col.field)) {
          // eslint-disable-next-line no-param-reassign
          col.visible = this.expandindoSituacaoGeral
        } else if (col.grupo && !['federal', 'certidoes', 'parcelamentos', 'simplesNacionalInfo'].includes(col.field)) {
          // eslint-disable-next-line no-param-reassign
          col.visible = false
        }
      })
    },
    visualizarGrupo(grupo) {
      const expandido = this.colunasExpandidas[grupo]
      this.colunasExpandidas[grupo] = !expandido

      this.visualizacao.colunas.forEach(col => {
        if (col.grupo === grupo && col.thType !== 'custom-header') {
          // eslint-disable-next-line no-param-reassign
          col.visible = !expandido
        }
      })
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.monitoramentoList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.monitoramentoList.aplicarFiltro(params.busca, filtroRapido)
        }
      })
      this.aplicarLegenda()
    },
    aplicarLegenda() {
      const interval = setInterval(() => {
        const totalPaginadoDiv = document.getElementById('TotalPagina')
        const spanElement = this.$refs.legenda
        totalPaginadoDiv.appendChild(spanElement)
        clearInterval(interval)
      }, 100)
    },
    abrirPendencias(row) {
      this.empresaSelecionada = row
    },
    baixarDocumentos(row) {
      this.descricaoLoading = 'Aguarde!'
      this.isLoading = true
      api.baixarDocumentos(row.id).then(payload => {
        window.open(payload.data)
      }).catch(() => {
        this.$erro('Não foi possível gerar o download dos documentos')
      }).finally(() => {
        this.isLoading = false
        this.descricaoLoading = ''
      })
    },
    visualizarDocumentos(row) {
      this.descricaoLoading = 'Estamos quase lá! Sua visualização está sendo preparada. Aguarde alguns instantes.'
      this.isLoading = true
      api.visualizarDocumentos(row.id).then(payload => {
        this.urlVisualizacao = payload.data
        this.mostrarVisualizacao = true
      }).catch(() => {
        this.$erro('Não foi possível gerar a visualização dos documentos')
      }).finally(() => {
        this.isLoading = false
        this.descricaoLoading = ''
      })
    },
    fecharVisualizacao() {
      this.mostrarVisualizacao = false
      this.urlVisualizacao = null
    },
    openModalObservacao(row) {
      this.empresaObservacao = row
      this.$nextTick(() => {
        if (this.$refs.modalObservacao) {
          this.$refs.modalObservacao.show()
        } else {
          this.$once('hook:updated', () => {
            if (this.$refs.modalObservacao) this.$refs.modalObservacao.show()
          })
        }
      })
    },
    getObservacaoClass(row) {
      const estado = this.observacaoEstado[row.id]
      const todasLidas = estado ? estado.todasObservacoesLidas : row.todasObservacoesLidas
      const temNaoLidas = estado ? estado.temObservacoesNaoLidas : row.temObservacoesNaoLidas
      return {
        'text-success': todasLidas,
        'text-warning': !todasLidas && temNaoLidas,
        'text-primary': !temNaoLidas && !todasLidas,
      }
    },
    fecharObservacao(event) {
      if (this.empresaObservacao) {
        this.$set(this.observacaoEstado, this.empresaObservacao.id, {
          temObservacao: !!(event.hasObservacaoNova || event.observacaoLida),
          temObservacoesNaoLidas: !!event.hasObservacaoNova,
          todasObservacoesLidas: !!event.observacaoLida,
        })
      }
      this.empresaObservacao = null
    },
    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      return api.getPaginado(pagina, tamanhoPagina, filtro, this.filtroString)
    },
    executarFiltro() {
      this.$refs.relatorioConsumoList.montarGrid(this.$refs.relatorioConsumoList.enviarServidor)
    },
    visibleColunas() {
      this.visualizacao.colunas.forEach(coluna => {
        if (this.filtroString.length > 0 && !this.filtroString.includes('Todos')) {
          const filtroStringModificada = this.filtroString.map(s => s.replace(/[.\-\\/\s]/g, '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
          if (!filtroStringModificada.some(s => s.includes(coluna.field.replace('consumo', '').toLowerCase()))
            && this.arrayColunas.includes(coluna.field)) {
            // eslint-disable-next-line no-param-reassign
            coluna.visible = false
          } else {
            // eslint-disable-next-line no-param-reassign
            coluna.visible = true
          }
        } else {
          if (this.filtroString.length > 0) {
            this.filtroString = ['Todos']
          }
          // eslint-disable-next-line no-param-reassign
          coluna.visible = true
        }
      })
    },
  },
}
</script>
